import React, { forwardRef, memo } from 'react'

const RefreshIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="56.7"
      height="56"
      viewBox="0 0 56.7 56"
      fill="none"
      {...props}>
      <circle
        cx="28.525"
        cy="28"
        r="26.871"
        fill="white"
        stroke="#EEEEEE"
        strokeWidth="2.259"
      />
      <path
        d="M25.025 25.2H20.825V21"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.825 25.2006L23.2995 22.7261C24.7325 21.2931 26.6727 20.1828 28.6993 20.171C30.7259 20.1592 32.6754 20.7469 34.125 21.6621"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.025 30.8H36.225V35"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.225 30.8L33.7505 33.2745C32.3175 34.7075 30.3773 35.8178 28.3507 35.8296C26.3241 35.8414 24.3746 35.2537 22.925 34.3385"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

RefreshIcon.displayName = 'RefreshIcon'

export default memo(RefreshIcon)
